import { SCHEMA_CONTEXT } from '@config/global';
import { ILocaleConfig } from '@interfaces';

export const getHomePageSeoSchema = (hostUrl: string, localeConfig: ILocaleConfig): any => {
    // Trigger Organization for homepage
    const code = localeConfig.code === 'au' ? 'cruiseaway' : localeConfig.code;
    return {
        '@context': SCHEMA_CONTEXT,
        '@type': 'Organization',
        name: 'Dreamlines',
        url: hostUrl,
        logo: `https://www.${localeConfig.url}/wp-content/themes/${code}/images/logos/dreamlines-logo.svg`,
    };
};
